/*
  Заведение полученного приказа - §3.6.

  Стоит на карточке счёта, а не в разделе «Исполнение», по одной причине: приказ
  относится к счёту, и здесь этот счёт уже открыт. В общем разделе пришлось бы
  выбирать его из всего портфеля - и первым же делом искать по номеру.

  До 09.09.2026 формы не было вовсе: реестр наполнялся сеятелем демонстрационных
  данных, а раздел «Исполнение» умел только показывать. Всё, что живёт после
  суда - сроки предъявления, находки радара, индексация, - у заказчика опиралось
  на данные, которых он не мог ввести.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { Field, Notice } from './Common.jsx'
import CourtField from './CourtField.jsx'

const EMPTY = {
  case_number: '',
  court_name: '',
  issued_on: '',
  effective_on: '',
  awarded_amount: '',
}

export default function EnforcementForm({ accountId, sections, sectionsError, onDone }) {
  const [form, setForm] = useState(EMPTY)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  const change = (field) => (event) => setForm({ ...form, [field]: event.target.value })
  const ready =
    form.case_number.trim() &&
    form.issued_on &&
    form.effective_on &&
    Number(form.awarded_amount) > 0

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const saved = await api.registerOrder({
        account_id: accountId,
        case_number: form.case_number.trim(),
        court_name: form.court_name.trim() || null,
        issued_on: form.issued_on,
        effective_on: form.effective_on,
        awarded_amount: form.awarded_amount,
      })
      setForm(EMPTY)
      onDone(
        `Приказ по делу № ${saved.case_number} заведён. Срок предъявления виден в разделе «Исполнение».`,
        'ok',
      )
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section card">
      <h2 className="section__title">Приказ получен</h2>
      <form onSubmit={submit}>
        <div className="row">
          <Field label="Номер дела" width="s">
            <input
              className="field__input"
              value={form.case_number}
              onChange={change('case_number')}
              placeholder="2-81/2026"
              required
            />
          </Field>
          {/*
            Участок выбирается из заведённых, но НЕ подставляется сам
            (14.09.2026): это свершившийся факт из полученного приказа, а не
            решение системы о подсудности. Приказ мог вынести другой суд - и
            подставленное значение человек подтвердил бы, не читая.

            Подсказки в поле нет намеренно: на карточке счёта уже есть поле
            участка - у сборки пакета, - и одинаковая подсказка у двух полей
            означала бы, что человек (и сквозной сценарий) их не различает.
            Название поля здесь говорит само: суд, вынесший приказ.
          */}
          <CourtField
            label="Суд, вынесший приказ"
            value={form.court_name}
            onChange={(name) => setForm({ ...form, court_name: name })}
            sections={sections}
            error={sectionsError}
          />
        </div>
        <div className="row">
          <Field label="Вынесен" width="s">
            <input
              className="field__input"
              type="date"
              value={form.issued_on}
              onChange={change('issued_on')}
              required
            />
          </Field>
          <Field label="Вступил в силу" width="s">
            <input
              className="field__input"
              type="date"
              value={form.effective_on}
              onChange={change('effective_on')}
              required
            />
          </Field>
          <Field label="Присуждено, ₽" width="s">
            <input
              className="field__input"
              type="number"
              step="0.01"
              min="0.01"
              value={form.awarded_amount}
              onChange={change('awarded_amount')}
              required
            />
          </Field>
          <button className="button" type="submit" disabled={busy || !ready}>
            Завести в реестр
          </button>
        </div>
      </form>
      {/* Пояснения стоят ПОД строкой с кнопкой: внутри строки они удлинили бы
          поле снизу и увели кнопку вниз (правило 6г скилла). */}
      <div className="muted">
        Срок предъявления считается от дня вступления в силу и продлевается каждым
        удержанием. Суд нужен для заявления об индексации: оно подаётся туда же.
      </div>
      {error ? <Notice error={error} /> : null}
    </section>
  )
}
